import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaPlusCircle } from 'react-icons/fa';
import { AppHeader } from './AppHeader';
import { useResponsive } from '../hooks/useResponsive';
import { useFeatureFlags } from '../contexts/FeatureFlagContext';
import { theme } from '../theme';

const PlayHubPage: React.FC = () => {
  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  const flags = useFeatureFlags() as Record<string, any>;
  const publicMatchDiscover = Boolean(flags.PUBLIC_MATCH_DISCOVER);

  const SearchIcon = FaSearch as React.ComponentType<{ size?: number; style?: React.CSSProperties }>;
  const PlusIcon = FaPlusCircle as React.ComponentType<{ size?: number; style?: React.CSSProperties }>;

  const cards = [
    publicMatchDiscover && {
      icon: SearchIcon,
      title: 'Unirme a un partido',
      subtitle: 'Buscá por zona, fecha y nivel',
      onPress: () => navigate('/discover'),
    },
    {
      icon: PlusIcon,
      title: 'Crear partido',
      subtitle: 'Armá tu partido paso a paso',
      onPress: () => navigate('/create-match'),
    },
  ].filter(Boolean) as Array<{
    icon: React.ComponentType<{ size?: number; style?: React.CSSProperties }>;
    title: string;
    subtitle: string;
    onPress: () => void;
  }>;

  return (
    <div
      style={{
        minHeight: '100vh',
        background: theme.colors.background,
        padding: isMobile ? '80px 16px 20px' : '20px 40px',
      }}
    >
      <AppHeader title="Jugar" showBackButton />

      <div style={{ maxWidth: 720, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: theme.colors.text, margin: 0, fontFamily: theme.fonts.heading }}>
            ¿Qué querés hacer?
          </h1>
          <p style={{ fontSize: 15, color: theme.colors.textSecondary, marginTop: 6 }}>
            {publicMatchDiscover
              ? 'Elegí si querés sumarte a un partido existente o crear uno nuevo.'
              : 'Creá un partido y armá tu equipo.'}
          </p>
        </div>

        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <button
              type="button"
              key={c.title}
              onClick={c.onPress}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                padding: '20px 18px',
                background: theme.colors.surface,
                border: `1px solid ${theme.colors.border}`,
                borderRadius: 16,
                cursor: 'pointer',
                textAlign: 'left',
                width: '100%',
                boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
              }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 22,
                  background: theme.colors.background,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <Icon size={22} style={{ color: theme.colors.primary }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 17, color: theme.colors.text }}>{c.title}</div>
                <div style={{ fontSize: 13, color: theme.colors.textSecondary, marginTop: 2 }}>{c.subtitle}</div>
              </div>
              <div style={{ color: theme.colors.textSecondary, fontSize: 22 }}>›</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PlayHubPage;
